var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenDoorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2922 15.5195L11.2921 15.5195L3.09464 16.6124C3.09441 16.6124 3.09418 16.6124 3.09395 16.6125C3.07588 16.6151 3.0577 16.6165 3.03956 16.6167C3.03797 16.6168 3.03616 16.6168 3.03418 16.6168H0.847794C0.60068 16.6168 0.4 16.4163 0.4 16.169C0.4 15.9219 0.600506 15.7212 0.847794 15.7212H2.58639V0.864762C2.58639 0.617648 2.7869 0.416968 3.03419 0.416968L13.9658 0.417089C14.2129 0.417089 14.4136 0.617594 14.4136 0.864883V15.7214H16.1182L16.1183 15.7213H16.152C16.3992 15.7213 16.5999 15.9219 16.5998 16.1692L11.2922 15.5195ZM11.2922 15.5195C11.5147 15.4897 11.6806 15.3001 11.6806 15.0758L11.6807 2.50468C11.6807 2.2804 11.5148 2.09061 11.2922 2.0609L11.2922 2.0609M11.2922 15.5195L11.2922 2.0609M11.2922 2.0609L5.68095 1.3127M11.2922 2.0609L5.68095 1.3127M5.68095 1.3127H13.5181V16.1692C13.5181 16.4165 13.7188 16.617 13.9659 16.617H16.152C16.3992 16.617 16.5997 16.4163 16.5998 16.1692L5.68095 1.3127ZM10.7848 2.89693V14.684L3.48201 15.6579V1.92301L10.7848 2.89693Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97856 9.13958C9.58528 9.13958 10.0788 8.6461 10.0788 8.03958C10.0788 7.43305 9.58528 6.93958 8.97856 6.93958C8.37215 6.93958 7.87891 7.43305 7.87891 8.03958C7.87868 8.6463 8.37215 9.13958 8.97856 9.13958Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenDoorIcon);
export default __webpack_public_path__ + "static/media/open-door-icon.d8d7971879fabca24fc9fde240b5a65c.svg";
export { ForwardRef as ReactComponent };